__turbopack_context__.v({
  "absolute": "box-module-scss-module__aPqOtW__absolute",
  "align-flex-end": "box-module-scss-module__aPqOtW__align-flex-end",
  "align-flex-start": "box-module-scss-module__aPqOtW__align-flex-start",
  "align-space-around": "box-module-scss-module__aPqOtW__align-space-around",
  "align-space-between": "box-module-scss-module__aPqOtW__align-space-between",
  "box": "box-module-scss-module__aPqOtW__box",
  "column": "box-module-scss-module__aPqOtW__column",
  "column-reverse": "box-module-scss-module__aPqOtW__column-reverse",
  "fixed": "box-module-scss-module__aPqOtW__fixed",
  "grow": "box-module-scss-module__aPqOtW__grow",
  "justify-flex-end": "box-module-scss-module__aPqOtW__justify-flex-end",
  "justify-flex-start": "box-module-scss-module__aPqOtW__justify-flex-start",
  "justify-space-around": "box-module-scss-module__aPqOtW__justify-space-around",
  "justify-space-between": "box-module-scss-module__aPqOtW__justify-space-between",
  "pad-bottom": "box-module-scss-module__aPqOtW__pad-bottom",
  "pad-horizontal": "box-module-scss-module__aPqOtW__pad-horizontal",
  "pad-left": "box-module-scss-module__aPqOtW__pad-left",
  "pad-right": "box-module-scss-module__aPqOtW__pad-right",
  "pad-top": "box-module-scss-module__aPqOtW__pad-top",
  "pad-vertical": "box-module-scss-module__aPqOtW__pad-vertical",
  "relative": "box-module-scss-module__aPqOtW__relative",
  "rounded": "box-module-scss-module__aPqOtW__rounded",
  "row": "box-module-scss-module__aPqOtW__row",
  "row-reverse": "box-module-scss-module__aPqOtW__row-reverse",
  "shadow": "box-module-scss-module__aPqOtW__shadow",
  "shrink": "box-module-scss-module__aPqOtW__shrink",
  "static": "box-module-scss-module__aPqOtW__static",
  "sticky": "box-module-scss-module__aPqOtW__sticky",
  "with-background-image": "box-module-scss-module__aPqOtW__with-background-image",
});
